import { DataGrid } from '@mui/x-data-grid';
import { Tooltip } from '@mui/material';

import React, { useState, useEffect } from 'react';

export default function TableStructure({ rows, columns, handleRowClick }) {
    const [key, setKey] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setKey(prev => prev + 1);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // for showing ellipsis in the table for large text
    const processedColumns = columns.map(column => ({
        ...column,
        renderCell: column.renderCell || (params => (
            <div style={{ 
                overflow: 'hidden', 
                textOverflow: 'ellipsis', 
                whiteSpace: 'nowrap',
                width: '100%' 
            }}>
                {params.value}
            </div>
        ))
    }));
    

    return (
        <div key={key}>
            <DataGrid
                rows={rows}
                columns={processedColumns}
                onRowClick={(e) => handleRowClick(e)}
                autoHeight
                disableColumnMenu
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                }}
                rowHeight={80}
                hideFooterPagination={true}
                hideFooter={true}
                sx={{
                    cursor: 'pointer',
                    width: '100%',
                    border: '1px solid #E1E1E1 !important',
                    borderRadius: '12px',
                    fontFamily: 'Poppins',
                    fontStyle: 'normal',
                    '.MuiDataGrid-main': {
                        borderRadius: '12px',
                        width: '100%',
                        overflow: 'hidden',
                        border: 'none !important',
                    },
                    '.MuiDataGrid-root': {
                        border: '1px solid #E1E1E1 !important',
                    },
                    '.MuiDataGrid-columnHeaderTitle': {
                        color: '#6B7280',
                        fontFamily: 'Poppins, serif',
                        fontSize: '12px',
                        fontStyle: 'normal',
                        fontWeight: '700',
                        lineHeight: 'normal',
                        textTransform: 'uppercase',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        '@media (max-width: 640px)': {
                            fontSize: '11px !important', // Prevent shrinking too much on mobile
                        },
                    },
                    // Force header text color across contexts where MUI overrides apply
                    '& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle': {
                        color: '#6B7280 !important',
                    },
                    '.MuiDataGrid-columnHeaders div': {
                        backgroundColor: '#E1E1E1',
                    },
                    '.MuiDataGrid-row': {
                        backgroundColor: 'rgba(255, 255, 255, 0.4) !important',
                        transition: 'background-color 0.3s ease',
                        borderTop: '1px solid #E1E1E1',
                        '&:hover': {
                            backgroundColor: '#FFFFFF !important',
                            '& svg path': {
                                stroke: '#ff5f39 !important',
                            },
                        },
                        '&:active': {
                            backgroundColor: 'rgba(255, 255, 255, 0.4) !important',
                            transition: 'background-color 0.1s ease',
                        },
                        '&:first-of-type': {
                            borderTop: '1px solid #9ca3af',
                        },
                    },
                    '.MuiDataGrid-row.Mui-selected': {
                        backgroundColor: 'rgba(255, 255, 255, 0.4) !important',
                        '&:hover': {
                            backgroundColor: '#FFFFFF !important',
                        },
                    },
                    '.MuiDataGrid-cell,.MuiDataGrid-columnHeader': {
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        padding: '12px 8px 12px 16px !important',
                        margin: 0,
                        boxSizing: 'border-box',
                        outline: 'none !important',
                        border: 'none !important',
                        fontSize: '14px', // Base font size
                        '@media (max-width: 640px)': {
                            fontSize: '12px !important', // Prevent shrinking too much on mobile
                        },
                    },
                    '.MuiDataGrid-cell:focus': {
                        outline: 'none !important',
                        border: 'none !important',
                        boxShadow: 'none !important',
                    },
                    '.MuiDataGrid-cell.Mui-focused': {
                        outline: 'none !important',
                        border: 'none !important',
                        boxShadow: 'none !important',
                    },
                    '& .MuiDataGrid-columnSeparator': {
                        display: 'none',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: 'none',
                        maxHeight: '40px',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        maxHeight: '40px',
                        padding: '8px 8px 8px 16px !important',
                    },
                    '& .MuiDataGrid-columnHeader:first-of-type': {
                        borderTopLeftRadius: '11px',
                    },
                    '& .MuiDataGrid-columnHeader:last-of-type': {
                        borderTopRightRadius: '11px',
                    },
                    '& .MuiDataGrid-virtualScroller': {
                        marginTop: '0 !important',
                        overflow: 'hidden !important',
                    },
                    '& .MuiDataGrid-virtualScrollerContent': {
                        width: '100% !important',
                    },
                    '& .MuiDataGrid-columnHeadersInner': {
                        width: '100% !important',
                    },
                    '& .MuiDataGrid-virtualScrollerRenderZone': {
                        width: '100% !important',
                    },
                    '& .MuiDataGrid-overlay': {
                        display: 'none !important',
                    },
                    '& .MuiDataGrid-overlayWrapper': {
                        display: 'none !important',
                    },
                    '& .empty .MuiDataGrid-columnHeaders': {
                        borderBottom: '1px solid #9ca3af !important',
                    },
                    '& .empty .MuiDataGrid-virtualScroller': {
                        backgroundColor: 'white !important',
                    },
                }}
            />
        </div>
    );
}
